import type { Nullable } from '@ats/interfaces';

export interface CompanyInfoDTO {
  companyName: string;
  managerName: string;
  managerEmail: string;
  managerPhone: string;
  loginLogo: string;
  loginBackground: string;
  loginColor: string;
  drmYn: boolean;
}

export interface LoginDTO {
  name: string;
  certificationCode: string;
}

export interface AttendeeInfoDTO {
  applySector: Nullable<string>;
  displayNo: number;
  name: string;
  recruitNoticeName: string;
}

export enum LogType {
  INTERVIEWER_PREPARED = 'INTERVIEWER_PREPARED',
  INTERVIEWEE_PREPARED = 'INTERVIEWEE_PREPARED',
}

export interface LogReqDTO extends LoginDTO {
  companyUrl: string;
  logType: LogType;
}

export type LogResDTO = boolean;
